import * as S from './styles'

const Loading = () => {
  return (
    <S.Container>
        <S.Ring />
        <S.Ring />
        <S.Ring />
    </S.Container>
  )
}

export default Loading
